import React from "react";
/**
 *
 * @param {Array} items list of object with id and name
 * @param {function} onSelect a function to call on an item selected
 * @param {string} title title of the control/label
 * @param {string} displayText prop for the control
 * @param {string} value text to display
 */
const DropdownList = ({ items = [], onSelect, title, value = "id", displayText = "name", id = "select-id" }) => {
    return (
        <>
            <label htmlFor={id}>{title}</label>
            <select
                id={id}
                onChange={e => {
                    const { value } = e.target;
                    const item = items[value];
                    onSelect(item);
                }}
                className="custom-select input-height"
            >
                <option value="0">Please Select</option>
                {items.map((item, index) => (
                    <option key={item[value]} value={index}>
                        {item[displayText]}
                    </option>
                ))}
            </select>
        </>
    );
};

export default DropdownList;
